/**
=========================================================
* Renix redesign — MuiChip override (new)
=========================================================
* Small hairline chips (radius sm, 12px). Colored chip variants (color="primary" etc.)
* keep their MUI treatment; only geometry + the default/outlined border are set here.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderColor } = colors;
const { borderRadius } = borders;
const { size, fontWeightRegular } = typography;

const chip = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.sm,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      height: pxToRem(24),
    },
    outlined: {
      borderColor: borderColor.main,
    },
    label: {
      paddingLeft: pxToRem(8),
      paddingRight: pxToRem(8),
    },
  },
};

export default chip;
